import React from "react";
import PropTypes from "prop-types";
import MaximizeIcon from "../resources/Maximise.png";
const ChatBar = props => {
  if (props.show === false) {
    return null;
  }
  const buClass = props.businessUnit === 2 ? "light-red-gradient" : "light-blue-gradient";
  return /*#__PURE__*/React.createElement("button", {
    id: "chat-bar-button",
    className: buClass,
    onClick: props.onClick
  }, "Chat about this delivery", /*#__PURE__*/React.createElement("img", {
    alt: "Maximize Chat",
    src: MaximizeIcon
  }));
};
ChatBar.propTypes = {
  show: PropTypes.bool,
  businessUnit: PropTypes.number,
  onClick: PropTypes.func
};
export default ChatBar;